export function loadUrls(ctx, payload) {
    return ctx.dispatch('LOAD_URLS', payload);
}
